import TrainingPackagedDetails from "./TrainingPackagedDetails";

export default TrainingPackagedDetails;
